<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="bk-title">Framley Parsonage</p>
<p class="authorname">Anthony Trollope</p>
<p class="publisher"><img alt="image" src="Book1/image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?b5d41a66